import {Model} from '@vuex-orm/core';
import UnitPlan from '@/store/units/UnitPlan';
import {IUnitPlanPreLearning} from '@/interfaces/planner/purpose/IUnitPlanPreLearning';

// @ts-ignore
export default class UnitPlanPreLearning extends Model implements IUnitPlanPreLearning {
    static entity = 'unit_plan_prelearnings';

    static fields () {
        return {
            id: this.number(0),
            preLearning_id: this.number(null),
            unitplan_id: this.number(null),
            created_at: this.string(new Date().toISOString().substr(0, 10)),
            update_at: this.string(new Date().toISOString().substr(0, 10)),

            preLearning: this.hasOne('', 'id'),
            unitplan: this.belongsTo(UnitPlan, 'unitplan_id'),
        };
    }
}
